import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';

import { history } from './store';

// VIEW COMPONENTS:
import CustomerCareUser from './components/CustomerCare/User';
import CustomerCareHelpDesk from './components/CustomerCare/HelpDesk';

const routes = (
  <ConnectedRouter history={history}>
      <Switch>
        <Route exact path="/:cp/user" component={CustomerCareUser} />
        <Route exact path="/:cp/helpdesk" component={CustomerCareHelpDesk} />
      </Switch>
  </ConnectedRouter>
);

export default routes;
